<template>
  <v-container id="productos_restaurante" tag="section">
    <base-v-component heading="Productos del Restaurante " />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn
          color="success"
          dark
          class="mb-2 mr-4"
          :loading="loadingSave"
          @click="saveAsociaciones()"
          >{{ formTitle }}</v-btn
        >
        <v-select
          class="mt-4"
          :items="categorias"
          v-model="categoria"
          label="Categoria"
        ></v-select>
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="productosRestCombinados"
        :loading="loading"
        :search="search"
      >
        <template v-slot:item.imagen="{ item }">
          <v-img
            v-if="item.imagen"
            :src="item.imagen"
            aspect-ratio="2"
            width="135px"
          ></v-img>
          <span v-else>sin imagen</span>
        </template>
        <template v-slot:item.precio="{ item }">
          <v-row v-if="item.asociado">
            <v-col cols="6">
              <v-text-field
                v-if="item.asociado"
                type="number"
                step="0.5"
                label="Precio del restaurante"
                v-model="item.precioRest"
                @input="changePrecio(item)"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select
                :items="impuestos"
                label="Impuesto asociado"
                v-model="item.impuesto"
                @input="changeImpuesto(item)"
              />
            </v-col>
          </v-row>
          <span v-else>{{ item.precioGlobal }}</span>
        </template>
        <template v-slot:item.acciones="{ item }">
          <v-card-actions class="pa-0 ma-0">
            <v-spacer />

            <v-btn
              v-if="item.asociado && item.tieneOpciones"
              class="px-2 ml-1"
              color="info"
              min-width="0"
              @click="openOpciones(item)"
              small
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>

            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="
                    !esCentralizadoMapeoNeo ||
                    !!restGest.mapeoNeoRestauranteForzado
                  "
                  class="px-2 ml-1"
                  small
                  min-width="0"
                  :color="getColor(item)"
                  @click="openDialogMapeando(item)"
                  v-on="on"
                >
                  <v-icon small>mdi-link</v-icon>
                </v-btn>
              </template>
              <span>Mapeo Neo por restaurante</span>
            </v-tooltip>
            <v-switch
              class="ml-2"
              v-model="item.asociado"
              @change="changeAsociado(item)"
            />
          </v-card-actions>
        </template>
      </v-data-table>
    </base-material-card>
    <!--Dialogo opciones asociadas-->
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-actions>
          <v-btn text @click="close">Guardar</v-btn>
        </v-card-actions>
        <v-card-text>
          <v-container grid-list-md>
            <v-row
              v-for="itemOp in opcionesProductosRestCombinado"
              :key="itemOp.id"
            >
              <template v-if="itemOp.panel">{{ itemOp.nombre }}</template>
              <template v-else>
                <v-row align="center">
                  <v-col cols="6">
                    <span>{{ itemOp.nombre }}</span>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      v-if="itemOp.asociado"
                      type="number"
                      step="0.5"
                      label="Precio del restaurante"
                      v-model="itemOp.precio"
                      @input="changePrecioOpcion(itemOp)"
                    />
                    <span v-else>{{ itemOp.precio }}</span>
                  </v-col>
                  <v-col cols="2">
                    <v-switch
                      @change="changeAsociadoOpcion(itemOp)"
                      v-model="itemOp.asociado"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          small
                          text
                          v-on="on"
                          :color="itemOp.mapeo ? 'green' : 'red'"
                          @click="openDialogOpcionesMapeando(itemOp)"
                        >
                          <v-icon>mdi-link</v-icon>
                        </v-btn>
                      </template>
                      <span v-if="itemOp.mapeo">{{ itemOp.mapeo }}</span>
                      <span v-else>Sin mapear</span>
                    </v-tooltip>

                    <!--<v-switch @change="changeAsociadoOpcion(itemOp)" v-model="itemOp.asociado" />-->
                  </v-col>
                </v-row>
              </template>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Dialogo mapeo productos por restaurante -->
    <v-dialog v-model="dialogMapeo">
      <v-card>
        <v-card-title>
          <span class="headline">Producto {{ nombreItemMapeando }}</span>
        </v-card-title>
        <div class="sticky">
          <v-card-title class="headline"
            >Resto de restaurantes y su mapeo</v-card-title
          >
          <v-card-text>
            <v-list v-for="(rest, index) in restoDeRestaurantes" :key="index">
              <v-list-item>
                <v-list-item-title
                  >{{ rest.nombre }} | Actual mapeado: {{ rest.actual }} |
                  Sugerencia: {{ rest.sugerencia }}</v-list-item-title
                >
                <v-list-item-action>
                  <v-switch
                    :disabled="rest.disabled"
                    label="Asociar"
                    v-model="rest.asociar"
                  />
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </div>

        <v-card-title class="headline"
          >Mapeo Neo {{ restGest.nombre }}</v-card-title
        >
        <v-card-text>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="searchNeo"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="getProductosNeoRestaurantes">
              <v-icon color="white">mdi-autorenew</v-icon>
            </v-btn>
            <v-btn color="success" @click="saveMapeo()" :loading="loadingMapeo">
              <v-icon color="white">mdi-floppy</v-icon>
            </v-btn>
          </v-toolbar>

          <v-data-table
            v-model="selectedNeo"
            item-key="Codigo"
            single-select
            :headers="headersNeo"
            :items="productosNeoRestaurante"
            :loading="loadingNeo"
            :search="searchNeo"
            show-select
          ></v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialogMapeo"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Dialogo mapeo opciones por restaurante -->
    <v-dialog v-model="dialogMapeoOpcion">
      <v-card>
        <v-card-title>
          <span class="headline"
            >Opción {{ opcionItemMapeando }} | {{ nombreItemMapeando }}</span
          >
        </v-card-title>
        <div class="sticky">
          <v-card-title class="headline"
            >Resto de restaurantes y su mapeo</v-card-title
          >
          <v-card-text>
            <v-list
              v-for="(rest, index) in restoDeRestaurantesOpcion"
              :key="index"
            >
              <v-list-item>
                <v-list-item-title>
                  <v-row align="center" justify="center"
                    ><v-col cols="12" md="6">
                      {{ rest.nombre }} | Actual mapeado: {{ rest.actual }} |
                      Sugerencia: {{ rest.sugerencia }}</v-col
                    >
                    <v-col cols="12" md="6">
                      <v-select
                        :items="rest.sugerenciasSelect"
                        :label="`sugerencias (${rest.sugerenciasSelect.length} posibilidad)`"
                        v-model="rest.sugerencia" /></v-col
                  ></v-row>
                </v-list-item-title>
                <v-list-item-action>
                  <v-switch
                    :disabled="rest.disabled"
                    label="Asociar"
                    v-model="rest.asociar"
                  />
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </div>

        <v-card-title class="headline"
          >Mapeo Neo {{ restGest.nombre }} | Mostrando
          {{
            mostrarTablaTodos
              ? "todos los productos"
              : "opciones del producto Neo"
          }}</v-card-title
        >
        <v-card-text>
          <v-toolbar flat color="white">
            <v-btn
              v-if="mostrarTablaTodos"
              @click="mostrarTablaTodos = false"
              color="primary"
              >Mostrar Opciones</v-btn
            >
            <v-btn v-else @click="mostrarTablaTodos = true" color="primary"
              >Mostrar Todos</v-btn
            >
            <v-text-field
              v-model="searchNeoOpcion"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="getProductosNeoRestaurantes">
              <v-icon color="white">mdi-autorenew</v-icon>
            </v-btn>
            <v-btn
              color="success"
              @click="saveMapeoOpcion()"
              :loading="loadingMapeo"
            >
              <v-icon color="white">mdi-floppy</v-icon>
            </v-btn>
          </v-toolbar>

          <v-data-table
            v-if="mostrarTablaTodos"
            v-model="selectedNeo"
            item-key="Codigo"
            single-select
            :headers="headersNeo"
            :items="productosNeoRestaurante"
            :loading="loadingNeo"
            :search="searchNeoOpcion"
            show-select
          ></v-data-table>
          <v-data-table
            v-else
            v-model="selectedNeoOpcion"
            item-key="Codigo"
            single-select
            :headers="headersNeoOpciones"
            :items="productosNeoOpciones"
            :loading="loadingNeo"
            :search="searchNeoOpcion"
            show-select
          ></v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialogMapeoOpcion"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>


<script>
import { mostrarIdioma } from "@/utils/utils.js";
import { mapState, mapGetters, mapActions } from "vuex";
var _ = require("lodash");
export default {
  data() {
    return {
      loadingNeo: false,
      loadingMapeo: false,
      itemMapeando: null,
      opcionMapeando: null,
      searchNeo: "",
      searchNeoOpcion: "",
      selectedNeo: [],
      selectedNeoOpcion: [],
      mostrarTablaTodos: false,
      loading: false,
      loadingSave: false,
      search: "",
      id: null,
      dialog: false,
      dialogMapeo: false,
      dialogMapeoOpcion: false,
      opcionesDialog: null,
      headers: [
        {
          sortable: false,
          text: "Imagen",
          value: "imagen",
        },
        {
          sortable: false,
          text: "Nombre",
          value: "nombreMostrar",
        },
        {
          sortable: false,
          text: "Precio",
          value: "precio",
        },
        {
          sortable: false,
          text: "Categoría",
          value: "categoriaMostrar",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
      headersNeo: [
        {
          sortable: false,
          text: "Codigo",
          value: "Codigo",
        },
        {
          sortable: false,
          text: "Nombre",
          value: "Nombre",
        },
        {
          sortable: false,
          text: "Tipo",
          value: "Tipo",
        },
      ],
      headersNeoOpciones: [
        {
          sortable: false,
          text: "Codigo",
          value: "Codigo",
        },
        {
          sortable: false,
          text: "Nombre",
          value: "nombreNeo",
        },
        {
          sortable: false,
          text: "Código Elemento",
          value: "codElemento",
        },
      ],
      productosNeoOpciones: [],
      productoEditando: null,
    };
  },
  computed: {
    opcionItemMapeando() {
      return this.opcionMapeando ? this.opcionMapeando.nombre : "";
    },
    productosRest() {
      return this.restGest.productosAsociados
        ? this.restGest.productosAsociados
        : [];
    },
    productosRestMapeo() {
      return this.restGest.productosMapeados
        ? this.restGest.productosMapeados
        : [];
    },
    nombreItemMapeando() {
      return this.itemMapeando ? mostrarIdioma(this.itemMapeando.nombre) : "";
    },
    opcionesProductosRestCombinado() {
      var res = [];
      var prd = [];
      //console.log(this.productosRest)
      let idFind = this.opcionesDialog ? this.opcionesDialog.id : null;
      let opcionesIterar = this.opcionesDialog
        ? this.opcionesDialog.opciones
        : [];
      var foundP = this.productosRest.find((e) => e.id == idFind);
      if (foundP) {
        var opcionesAsociadas = foundP.opciones;
      }
      opcionesIterar.forEach((p_aux) => {
        let aux = {
          nombre: this.mostrarIdioma(p_aux.panel),
          panel: true,
        };
        res.push(aux);
        p_aux.opciones.forEach((op) => {
          var foundOp = opcionesAsociadas
            ? opcionesAsociadas.find((o) => o.id == op.id)
            : false;
          let aux = {
            id: op.id,
            nombre: this.mostrarIdioma(op.title),
            precio: op.precio,
            asociado: false,
          };
          if (foundOp) {
            aux.precio = foundOp.precio ? foundOp.precio : 0;
            aux.asociado = foundOp.asociado;
          }
          aux.mapeo = this.checkMapeadoOpcion(op);
          res.push(aux);
        });
      });
      //prd.map((e) => e.nombreMostrar = this.mostrarIdioma(e.nombre))
      return res;
    },
    productosRestCombinados() {
      let prds = JSON.parse(JSON.stringify(this.productos));
      prds.forEach((p) => {
        let foundMapeo = this.productosRestMapeo.find((m) => m.id == p.id);
        if (foundMapeo) {
          p.mapeoRest = foundMapeo.mapeoRest;
        }
        var found = this.productosRest.find((aux) => aux.id == p.id);
        if (found) {
          p.asociado = true;
          p.precioRest = found.precioRest;
          p.impuesto = found.impuesto;
        }
      });
      return prds;
    },
    formTitle() {
      return this.isEdit ? "Editar Producto" : "Guardar Asociaciones";
    },
    dialogTitle() {
      return this.opcionesDialog
        ? mostrarIdioma(this.opcionesDialog.nombre)
        : "";
    },
    categoria: {
      get() {
        return this.$store.state.productos.categoriaFiltrar;
      },
      set(v) {
        this.$store.commit("productos/setCategoriaFiltrar", v);
      },
    },
    ...mapState({
      //productos : (state) => state.productos.productosArray,
      idiomas: "idiomas",
      langDefecto: "langDefecto",
      productosRestaurante: (state) => state.restaurantes.productosRestaurante,
      productosNeoRestauranteTodos: (state) =>
        state.neo.productosNeoRestauranteTodos,
      restGestionar: (state) => state.app.restauranteGest,
    }),
    productosNeoRestaurante() {
      let f = this.productosNeoRestauranteTodos
        .filter((r) => !!r)
        .find((p) => p.id == this.restGestionar);
      return f ? f.productos : [];
    },
    ...mapGetters({
      esCentralizadoMapeoNeo: "app/esCentralizadoMapeoNeo",
      negocio: "app/negocioGestObj",
      restGest: "app/restGestObj",
      productos: "productos/getProductosListado",
      categorias: "categorias/getCategoriasSelect",
      impuestos: "impuestos/getImpuestosSelect",
      restaurantesMapeos: "restaurantes/getAllProductosMapeadosRest",
    }),
    subtitle() {
      return "Listado de productos de " + this.negocio.nombre;
    },
    restoDeRestaurantesOpcion() {
      const rests = this.$store.state.restaurantes.restaurantesArray;
      const r = rests
        .filter((r) => r.id != this.restGestionar)
        .map((r) => {
          const found = this.productosNeoRestauranteTodos
            .filter((r) => !!r)
            .find((pTodos) => pTodos.id == r.id);
          const productos = found ? found.productos : [];
          let pFound = false;
          let pFoundArray = productos.filter(
            (p) => this.selectedNeo[0] && p.Nombre == this.selectedNeo[0].Nombre
          );
          if (pFoundArray.length > 0) {
            pFound = pFoundArray.find(
              (p) =>
                this.selectedNeo[0] && p.Codigo == this.selectedNeo[0].Codigo
            );
          }

          let pFoundOpcionArray = productos.filter(
            (p) =>
              this.selectedNeoOpcion[0] &&
              p.Nombre == this.selectedNeoOpcion[0].nombreNeo
          );
          let pFoundOpcion = false;
          if (pFoundOpcionArray.length > 0) {
            pFoundOpcion = pFoundOpcionArray.find(
              (p) =>
                this.selectedNeoOpcion[0] &&
                p.Codigo == this.selectedNeoOpcion[0].Codigo
            );
          }

          let foundRest = this.restaurantesMapeos.find((rM) => r.id == rM.id);
          let actual = null;
          if (foundRest && this.itemMapeando) {
            let mapeoRestConcreto = foundRest.mapeoNeo.find(
              (mapeo) => mapeo.id == this.itemMapeando.id
            );
            if (
              mapeoRestConcreto &&
              this.opcionMapeando &&
              mapeoRestConcreto.opciones
            ) {
              let foundOpcion = mapeoRestConcreto.opciones.find(
                (op) => op.id === this.opcionMapeando.id
              );
              actual = foundOpcion ? foundOpcion.mapeoRest : null;
            }
          }
          let asociar = pFound || pFoundOpcion ? true : false;
          let disabled = pFound || pFoundOpcion ? false : true;
          actual = actual ? actual : "Sin mapear";
          let sugerencia = pFoundOpcion
            ? pFoundOpcion.Codigo
            : pFound
            ? pFound.Codigo
            : "Sin sugerencia";
          let sugerenciasSelect = (
            pFoundOpcionArray.length > 0
              ? pFoundOpcionArray
              : pFoundArray.length > 0
              ? pFoundArray
              : []
          ).map((s) => {
            return {
              text: s.Nombre + " " + s.Codigo,
              value: s.Codigo,
            };
          });
          console.log(pFoundOpcionArray);
          console.log(pFoundArray);
          console.log(sugerenciasSelect);
          return {
            id: r.id,
            nombre: r.nombre,
            sugerencia: sugerencia,
            sugerenciasSelect: sugerenciasSelect,
            disabled: disabled,
            asociar: asociar,
            mapeoRest: r.mapeoRest,
            actual: actual,
          };
        });
      return r;
    },
    restoDeRestaurantes() {
      const rests = this.$store.state.restaurantes.restaurantesArray;
      const r = rests
        .filter((r) => r.id != this.restGestionar)
        .map((r) => {
          const found = this.productosNeoRestauranteTodos
            .filter((r) => !!r)
            .find((pTodos) => pTodos.id == r.id);
          const productos = found ? found.productos : [];
          let pFound = productos.find(
            (p) => this.selectedNeo[0] && p.Nombre == this.selectedNeo[0].Nombre
          );
          let foundRest = this.restaurantesMapeos.find((rM) => r.id == rM.id);
          let actual = null;
          if (foundRest && this.itemMapeando) {
            let mapeoRestConcreto = foundRest.mapeoNeo.find(
              (mapeo) => mapeo.id == this.itemMapeando.id
            );
            actual = mapeoRestConcreto ? mapeoRestConcreto.mapeoRest : null;
          }
          let asociar = pFound ? true : false;
          let disabled = pFound ? false : true;
          actual = actual ? actual : "Sin mapear";
          let sugerencia = pFound ? pFound.Codigo : "Sin sugerencia";
          return {
            id: r.id,
            nombre: r.nombre,
            sugerencia: sugerencia,
            disabled: disabled,
            asociar: asociar,
            mapeoRest: r.mapeoRest,
            actual: actual,
          };
        });
      return r;
    },
    mapeoProductoMapeando() {
      let f = this.productosRestMapeo.find(
        (pn) => pn.id == this.opcionesDialog.id
      );

      if (f) {
        return this.productosNeoRestaurante.find(
          (pnr) => pnr.Codigo == f.mapeoRest
        );
      }
    },
    mapeoOpcionMapeando() {
      let f = this.productosRestMapeo.find(
        (pn) => pn.id == this.itemMapeando.id
      );

      if (f && f.opciones) {
        let foundOp = f.opciones.find((op) => op.id === this.opcionMapeando.id);
        return this.productosNeoRestaurante.find(
          (pnr) => foundOp && pnr.Codigo == foundOp.mapeoRest
        );
      } else {
        return false;
      }
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogMapeo(val) {
      val || this.closeDialogMapeo();
    },
    dialogMapeoOpcion(val) {
      val || this.closeDialogMapeoOpcion();
    },
    selectedNeo(val) {
      if (val.length > 0) {
        this.selectedNeoOpcion = [];
      }
    },
    selectedNeoOpcion(val) {
      if (val.length > 0) {
        this.selectedNeo = [];
      }
    },
  },
  methods: {
    checkMapeadoOpcion(item) {
      let f = this.productosRestMapeo.find(
        (pn) => pn.id == this.productoEditando.id
      );

      if (f && f.opciones) {
        let foundOp = f.opciones.find((op) => op.id === item.id);
        return foundOp ? foundOp.mapeoRest : false;
      } else {
        return false;
      }
    },
    openDialogOpcionesMapeando(item) {
      var opcionesTabla = [];
      this.opcionMapeando = item;
      this.dialogMapeoOpcion = true;
      this.itemMapeando = this.opcionesDialog;

      if (this.mapeoOpcionMapeando) {
        this.selectedNeo.push(this.mapeoOpcionMapeando);
      }
      this.searchNeoOpcion = Array.isArray(item.nombre)
        ? mostrarIdioma(item.nombre)
        : item.nombre;
      let mapeoProducto = this.productoEditando.mapeoRest;
      let foundOpciones = this.productosNeoRestaurante.find(
        (e) => e.Codigo == mapeoProducto
      );
      if (
        foundOpciones &&
        foundOpciones.Elementos &&
        foundOpciones.Elementos.length > 0
      ) {
        let elementos = foundOpciones.Elementos;
        elementos.forEach((e) => {
          let codElemento = e.CodigoElemento;
          e.Opciones.forEach((op) => {
            opcionesTabla.push({
              Codigo: op.Componente,
              nombreNeo: op.NombreComponente,
              codElemento: codElemento,
            });
          });
        });
      }
      this.productosNeoOpciones = opcionesTabla;
      //marcamos en la tabla que corresponda el mapeo seleccionado
      let found2 = this.productosNeoOpciones.find(
        (e) => e.Codigo == item.mapeoNeo
      );
      if (found2) {
        this.selectedNeoOpcion.push(found2);
      } else {
        let found = this.productosNeoRestaurante.find(
          (e) => e.Codigo == item.mapeoNeo
        );
        if (found) this.selectedNeo.push(found);
      }
    },
    getProductosNeoRestaurantes() {
      let _vm = this;
      this.loadingNeo = true;
      this.$store
        .dispatch("negocios/getProductosNeoRestaurantes")
        .then((res) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Productos Neo por restaurantes cargados",
          });
        })
        .catch((error) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al conectar con Neo: " + error,
          });
        })
        .finally(() => {
          this.loadingNeo = false;
        });
    },
    saveMapeo() {
      let m = this.selectedNeo[0];
      let _vm = this;
      var mapeos = this.restoDeRestaurantes.map((r) => {
        if (r.asociar) {
          return {
            producto: this.itemMapeando.id,
            codigo: r.sugerencia,
            rest: r.id,
          };
        }
      });
      mapeos.push({
        producto: this.itemMapeando.id,
        codigo: this.selectedNeo[0].Codigo,
        rest: this.$store.state.app.restauranteGest,
      });
      this.loadingMapeo = true;
      return this.$store
        .dispatch("restaurantes/saveMapeoAsociados", mapeos)
        .then((res) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Mapeo correcto",
          });
          //_vm.getProductos();
          _vm.closeDialogMapeo();
        })
        .catch((error) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al mapear: " + error,
          });
        })
        .finally(() => {
          this.loadingMapeo = false;
        });
    },
    saveMapeoOpcion() {
      let m = this.selectedNeoOpcion[0]
        ? this.selectedNeoOpcion[0]
        : this.selectedNeo[0]
        ? this.selectedNeo[0]
        : null;

      let _vm = this;
      console.log(this.itemMapeando);

      var mapeos = this.restoDeRestaurantesOpcion
        .map((r) => {
          if (r.asociar) {
            return {
              producto: this.itemMapeando.id,
              codigo: r.sugerencia,
              rest: r.id,
              opcion: this.opcionMapeando.id,
            };
          }
        })
        .filter((r) => !!r);
      mapeos.push({
        producto: this.itemMapeando.id,
        codigo: m.Codigo, //this.selectedNeo[0].Codigo,
        opcion: this.opcionMapeando.id,
        rest: this.$store.state.app.restauranteGest,
      });
      this.loadingMapeo = true;
      return this.$store
        .dispatch("restaurantes/saveMapeoOpcionAsociados", mapeos)
        .then((res) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Mapeo correcto",
          });
          //_vm.getProductos();
          _vm.closeDialogMapeoOpcion();
        })
        .catch((error) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al mapear: " + error,
          });
        })
        .finally(() => {
          this.loadingMapeo = false;
        });
    },
    closeDialogMapeo() {
      this.dialogMapeo = false;
      let _vm = this;
      setTimeout(() => {
        _vm.reiniciarDatosMapeo();
      }, 300);
    },
    closeDialogMapeoOpcion() {
      this.dialogMapeoOpcion = false;
      let _vm = this;
      setTimeout(() => {
        _vm.reiniciarDatosMapeo();
      }, 300);
    },
    openDialogMapeando(item) {
      this.dialogMapeo = true;
      this.itemMapeando = item;
      this.searchNeo = mostrarIdioma(item.nombre);
      if (item.mapeoRest) {
        let found = this.productosNeoRestaurante.find(
          (e) => e.Codigo == item.mapeoRest
        );
        if (found) this.selectedNeo.push(found);
      }
    },
    reiniciarDatosMapeo() {
      this.itemMapeando = null;
      this.opcionMapeando = null;
      this.selectedNeo = [];
      this.selectedNeoOpcion = [];
    },
    getColor(item) {
      return item.mapeoRest ? "green" : "red";
    },
    mostrarIdioma(str) {
      return mostrarIdioma(str);
    },
    reload() {
      this.getProductos();
    },
    getProductos() {
      this.loading = true;
      let _vm = this;
      return this.$store.dispatch("productos/getProductos").finally(() => {
        _vm.loading = false;
      });
    },
    initNegocio() {
      let negocio = this.$route.params.negocio;
      this.$store.commit("app/setNegocioGest", negocio, { root: true });
    },
    close() {
      this.dialog = false;
      let _vm = this;
      setTimeout(() => {
        _vm.reiniciarDatos();
      }, 300);
    },
    reiniciarDatos() {
      this.opcionesDialog = null;
    },
    changeAsociado(item) {
      if (item.asociado) {
        let opciones = [];
        if (item.opciones) {
          item.opciones.forEach((p_aux) => {
            p_aux.opciones.forEach((op) => {
              let aux_op = {
                id: op.id,
                precio: op.precio ? op.precio : 0,
                asociado: true,
              };
              opciones.push(aux_op);
            });
          });
        }
        let aux = {
          id: item.id,
          impuesto: this.restGest.impuesto,
          precioRest: item.precioGlobal ? item.precioGlobal : 0,
          opciones: opciones,
        };
        this.productosRest.push(aux);
      } else {
        var i = this.productosRest.findIndex((e) => e.id == item.id);
        if (i >= 0) {
          _.pullAt(this.productosRest, i);
        }
      }
    },
    changePrecio(item) {
      var found = this.productosRest.find((e) => e.id == item.id);
      if (found) {
        found.precioRest = item.precioRest;
      }
    },
    changeImpuesto(item) {
      var found = this.productosRest.find((e) => e.id == item.id);
      if (found) {
        found.impuesto = item.impuesto;
      }
    },
    changeAsociadoOpcion(item) {
      var found = this.productosRest.find(
        (e) => e.id == this.opcionesDialog.id
      );
      if (found) {
        let ops = found.opciones;
        if (item.asociado) {
          var foundOpcionI = ops.findIndex((op) => op.id == item.id);
          if (foundOpcionI < 0) {
            let auxPush = {
              id: item.id,
              precio: item.precio ? item.precio : 0,
              asociado: true,
            };
            ops.push(auxPush);
            //_.pullAt(ops,foundOpcionI);
          }
        } else {
          var foundOpcionI = ops.findIndex((op) => op.id == item.id);
          if (foundOpcionI >= 0) {
            _.pullAt(ops, foundOpcionI);
          }
        }
      }
    },
    changePrecioOpcion(item) {
      var found = this.productosRest.find(
        (e) => e.id == this.opcionesDialog.id
      );
      if (found) {
        let ops = found.opciones;
        var foundOpcion = ops.find((op) => op.id == item.id);
        if (foundOpcion) {
          foundOpcion.precio = parseFloat(item.precio);
        }
      }
    },
    saveAsociacionesOpciones() {},
    saveAsociaciones() {
      this.loadingSave = true;
      let _vm = this;
      return this.$store
        .dispatch("restaurantes/saveProductosAsociados", this.productosRest)
        .then((r) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Asociaciones guardadas",
          });
        })
        .catch((e) => {
          console.log(e);
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar las asociaciones",
          });
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
    openOpciones(item) {
      this.productoEditando = item;
      this.opcionesDialog = item;
      this.dialog = true;
    },
  },
  mounted() {
    let _vm = this;
    //this.initNegocio()
    this.getProductos().then(() => {
      //this.categoria = this.categorias[0].value;
    });
  },
};
</script>

<style>
.v-dialog > .v-card > .sticky {
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 999;
}
</style>